<template>
  <div class="home mt-2">
    <a-row class="pl-2 pr-3">
      <a-col :span="24">
        <div style="margin-bottom:10px">
          <a-breadcrumb>
            <a-breadcrumb-item href>
              <a-icon type="home"/>
            </a-breadcrumb-item>
            <a-breadcrumb-item href>
              <a-icon type="user"/>
              <span>Users</span>
            </a-breadcrumb-item>
            <a-breadcrumb-item>New User</a-breadcrumb-item>
          </a-breadcrumb>
        </div>
      </a-col>
      <a-col :span="15">
        <h2 class="text-bold">Create New User</h2>
        <h5 style="line-height:20px" class="text-opacity">
          Create New user, assign roles, and update
          <br>User information here.
        </h5>
      </a-col>
    </a-row>

    <a-row class="pl-2 pr-3">
      <a-col :span="24">
        <users-card :user="user" :roles="roles"></users-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { setTimeout } from "timers";
import UsersCard from "@/components/Cards/Users";
export default {
  data() {
    return {
      hide: false,
      show: true,
      display: "password",
      form: this.$form.createForm(this, { name: "coordinated" }),
      location: {
        selected_country: "",
        selected_state: ""
      },
      user: {
        first_name: "",
        last_name: "",
        username: "",
        email: "",
        phone: "",
        password: "",
        country_id: "",
        state_id: "",
        city_id: "",
        postal_code: "",
        address: "",
        roles: []
      },
      roles: []
    };
  },
  components: { UsersCard },
  methods: {
    fetchRoles() {
      this.$store.dispatch("getRoles").then(s => {
        this.roles = s;
      });
    }
  },
  mounted() {
    this.fetchRoles();
  }
};
</script>
